import React from 'react';
import { formatMoneyCurrency } from '@/shared/utils/formatMoneyDisplay';
import { formatUnitPriceNetFourPlaces } from '@/shared/utils/formatUnitPriceNet';
import type { ConfiguredService } from '@features/service-plans';
import type { PricedLineFigures } from '../../types/basketPricing.types';
import { pricedItemFigures } from '../../utils/pricedLines';

interface ServiceItemLinesProps {
    items: ConfiguredService['items'];
    costMode: ConfiguredService['costMode'];
    currency: string;
    pricedLine?: PricedLineFigures;
}

export const ServiceItemLines: React.FC<ServiceItemLinesProps> = ({ items, costMode, currency, pricedLine }) => (
    <div className="mb-0">
        {items?.map((item, itemIndex) => {
            const figures = costMode === 'total' ? undefined : pricedItemFigures(pricedLine, item.pivot.item_id);
            return (
                <div key={itemIndex} className="flex justify-between text-sm pl-4">
                    <span className="text-mp-muted">{item.description}</span>
                    {figures ? (
                        <span className="font-medium">
                            <span className="text-mp-muted">
                                {item.pivot.unit_quantity} x {formatUnitPriceNetFourPlaces(item, currency)}
                            </span>{' '}
                            <span>{formatMoneyCurrency(figures.net, currency)}</span>
                        </span>
                    ) : (
                        <span className="font-medium">Qty: {item.pivot.unit_quantity}</span>
                    )}
                </div>
            );
        })}
    </div>
);
